module.exports = __webpack_public_path__ + "static/media/icon-double-chevon-right.016e2a5e.svg";